/** @jsx jsx */
import type { ReactNode } from 'react';
import React from 'react';
import type { ResponsiveProp } from '@balance-web/core';
import { jsx } from '@balance-web/core';
import { Flex } from '@balance-web/flex';
import { useMediaQuery } from '@balance-web/media-query';
import type { BalanceTheme } from '@balance-web/theme';
import { useTheme } from '@balance-web/theme';

import { useDefaultPageBlockSize } from './useDefaultPageBlockSize';

type PageBlockProps = {
  children: ReactNode;
  size?: ResponsiveProp<keyof BalanceTheme['breakpoints']>;
} & Parameters<typeof Flex>[0];

export const PageBlock = ({
  children,
  size,
  direction = 'column',
  ...props
}: PageBlockProps) => {
  const { mq, mapResponsiveProp } = useMediaQuery();
  const { spacing, breakpoints } = useTheme();
  const { size: contextSize } = useDefaultPageBlockSize();
  const sizeDirectiveToUse = size || contextSize || 'xlarge';
  const resolvedSize =
    typeof sizeDirectiveToUse === 'number'
      ? sizeDirectiveToUse
      : mapResponsiveProp(sizeDirectiveToUse, breakpoints);

  return (
    <Flex justifyContent="center" width="100%">
      <Flex
        css={mq({
          width: '100%',
          marginRight: mapResponsiveProp(sizeDirectiveToUse, spacing),
          marginLeft: mapResponsiveProp(sizeDirectiveToUse, spacing),
          maxWidth: resolvedSize,
        })}
        direction={direction}
        {...props}
      >
        {children}
      </Flex>
    </Flex>
  );
};
